import Component from "@glimmer/component"

export default class LessonMenuReplaceTemplateTitle extends Component {}
